import type { ArtifactVendor, ComparisonMatrix } from '../types.ts';
import { cellFor } from '../lib/artifact.ts';

/**
 * Which axes cite this feature/subfeature, each badge colored by that axis's cell verdict
 * (spec, vendor pivot: "badges showing which axes cite each feature"). `citedBy` is always a
 * subset of axes that have a real cell for this vendor (it's derived from matrix cells by the
 * artifact builder), so `cellFor` here should never miss — the `cell &&` guard is defensive,
 * not expected to trigger.
 */
export function CitationBadges({
  citedBy,
  vendor,
  matrix,
}: {
  citedBy: string[];
  vendor: ArtifactVendor;
  matrix: ComparisonMatrix;
}): JSX.Element | null {
  if (!citedBy.length) return null;
  return (
    <span className="citation-badges">
      {citedBy.map((axis) => {
        const cell = cellFor(matrix, axis, vendor.company);
        return (
          <span
            key={axis}
            className={`citation-badge${cell ? ` verdict-${cell.verdict}` : ''}`}
            title={cell ? `${axis}: ${cell.verdict}` : axis}
          >
            {axis}
          </span>
        );
      })}
    </span>
  );
}
